<app-resource-template [footerStickyEnabled]="footerStickyEnabled">
  <div resource-content class="terms-content" [innerHTML]="termsContent"></div>
</app-resource-template>
